export function initScrollToTop() {
    const button = document.querySelector('[data-scroll-to-top]');
    if (!button) {
        return;
    }

    button.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
    });
}
